var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('section',{staticClass:"widget text"},[(_vm.text.title.lenght > 0)?_c('h2',[_vm._v(_vm._s(_vm.text.title))]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.text.content)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }